import React from 'react';


const FormContext = React.createContext();


function FormProvider({ form, children }) {
  return <FormContext.Provider value={form}>{children}</FormContext.Provider>;
}

FormProvider.displayName = 'FormProvider';
export { FormContext, FormProvider };
